// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3i0k8","author":"Table_author__3pPH2","authorImage":"Table_authorImage__YGo1C","unreadRow":"Table_unreadRow__22VJU"};